
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-place/[companyname]",
      function () {
        return require("private-next-pages/funeral-place/[companyname]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-place/[companyname]"])
      });
    }
  